import { motion } from 'framer-motion';
import styled from 'styled-components';

const PrivacyWrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 4rem 2rem;
  line-height: 1.8;
`;

const Title = styled.h1`
  color: #2F4F4F;
  font-size: 2.5rem;
  margin-bottom: 2rem;
  text-align: center;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -10px;
    right: 50%;
    transform: translateX(50%);
    width: 100px;
    height: 3px;
    background: #D2A46E;
  }
`;

const Section = styled.section`
  margin-bottom: 3rem;
`;

const SectionTitle = styled.h2`
  color: #2F4F4F;
  font-size: 1.5rem;
  margin-bottom: 1rem;
  border-right: 4px solid #D2A46E;
  padding-right: 1rem;
`;

const Paragraph = styled.p`
  color: #666;
  margin-bottom: 1rem;
`;

const List = styled.ul`
  color: #666;
  padding-right: 2rem;
  
  li {
    margin-bottom: 0.5rem;
  }
`;

const ContactInfo = styled.div`
  background: #f8f9fa;
  padding: 2rem;
  border-radius: 10px;
  border-right: 4px solid #D2A46E;
  margin-top: 2rem;
`;

const Privacy = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <PrivacyWrapper>
        <Title>מדיניות פרטיות ועוגיות</Title>
        
        <Section>
          <SectionTitle>מבוא</SectionTitle>
          <Paragraph>
            אפיק לב - ייעוץ משכנתאות ("אנחנו", "שלנו", "האתר") מחויבת להגנה על פרטיותכם. 
            מדיניות פרטיות זו מסבירה כיצד אנו אוספים, משתמשים ומגינים על המידע האישי שלכם 
            בעת שימוש באתר שלנו, בהתאם לחוק הגנת הפרטיות התשמ"א-1981 ותקנות הגנת הפרטיות (אבטחת מידע) התשע"ז-2017.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>מידע שאנו אוספים</SectionTitle>
          <Paragraph>אנו עשויים לאסוף את סוגי המידע הבאים:</Paragraph>
          <List>
            <li><strong>מידע אישי:</strong> שם, כתובת דוא"ל, מספר טלפון, כתובת מגורים</li>
            <li><strong>מידע פיננסי:</strong> פרטי הכנסה, נכסים, התחייבויות (לצורך ייעוץ משכנתא)</li>
            <li><strong>מידע טכני:</strong> כתובת IP, סוג דפדפן, מערכת הפעלה, דפי האתר שביקרתם</li>
            <li><strong>עוגיות:</strong> מידע המאוחסן בדפדפן שלכם לשיפור חוויית הגלישה</li>
          </List>
        </Section>

        <Section>
          <SectionTitle>שימוש במידע</SectionTitle>
          <Paragraph>אנו משתמשים במידע שלכם למטרות הבאות:</Paragraph>
          <List>
            <li>מתן שירותי ייעוץ משכנתאות מותאמים אישית</li>
            <li>יצירת קשר איתכם בנושאי השירות</li>
            <li>שיפור השירותים והאתר שלנו</li>
            <li>עמידה בדרישות חוקיות ורגולטוריות</li>
            <li>שליחת עדכונים ומידע רלוונטי (רק בהסכמתכם)</li>
          </List>
        </Section>

        <Section>
          <SectionTitle>עוגיות (Cookies)</SectionTitle>
          <Paragraph>
            האתר שלנו משתמש בעוגיות לשיפור חוויית הגלישה. עוגיות הן קבצי טקסט קטנים 
            הנשמרים במחשב או במכשיר הנייד שלכם.
          </Paragraph>
          
          <SectionTitle>סוגי עוגיות שאנו משתמשים:</SectionTitle>
          <List>
            <li><strong>עוגיות נחוצות:</strong> נדרשות לתפקוד בסיסי של האתר</li>
            <li><strong>עוגיות אנליטיות:</strong> Google Analytics לניתוח תנועה באתר</li>
            <li><strong>עוגיות פונקציונליות:</strong> שמירת העדפות משתמש</li>
            <li><strong>עוגיות שיווק:</strong> הצגת תוכן רלוונטי (רק בהסכמתכם)</li>
          </List>
          
          <Paragraph>
            אתם יכולים לנהל את הגדרות העוגיות דרך הבאנר שמופיע באתר או דרך הגדרות הדפדפן שלכם.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>שיתוף מידע עם צדדים שלישיים</SectionTitle>
          <Paragraph>אנו לא מוכרים או משתפים את המידע האישי שלכם עם צדדים שלישיים, למעט:</Paragraph>
          <List>
            <li>ספקי שירות מקצועיים (עורכי דין, רואי חשבון) לצורך מתן השירות</li>
            <li>בנקים ומוסדות פיננסיים לצורך עיבוד בקשת המשכנתא</li>
            <li>כאשר נדרש על פי חוק או צו בית משפט</li>
            <li>Google Analytics לניתוח תנועה באתר (רק בהסכמתכם)</li>
          </List>
        </Section>

        <Section>
          <SectionTitle>אבטחת מידע</SectionTitle>
          <Paragraph>
            אנו נוקטים באמצעי אבטחה מתקדמים להגנה על המידע שלכם, כולל הצפנת SSL, 
            גישה מוגבלת למידע רגיש, ועדכון שוטף של מערכות האבטחה.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>זכויותיכם</SectionTitle>
          <Paragraph>בהתאם לחוק הגנת הפרטיות, יש לכם את הזכויות הבאות:</Paragraph>
          <List>
            <li>זכות עיון במידע האישי שלכם</li>
            <li>זכות לתיקון מידע שגוי או לא מדויק</li>
            <li>זכות למחיקת מידע (במקרים מסוימים)</li>
            <li>זכות להתנגד לעיבוד מידע למטרות שיווק</li>
            <li>זכות לביטול הסכמה לעוגיות</li>
            <li>זכות להגשת תלונה לרשות להגנת הפרטיות</li>
          </List>
        </Section>

        <Section>
          <SectionTitle>שינויים במדיניות</SectionTitle>
          <Paragraph>
            אנו עשויים לעדכן מדיניות פרטיות זו מעת לעת. שינויים מהותיים יפורסמו באתר 
            ויישלחו אליכם בדוא"ל (אם ביקשתם לקבל עדכונים).
          </Paragraph>
        </Section>

        <ContactInfo>
          <SectionTitle>יצירת קשר</SectionTitle>
          <Paragraph>
            לשאלות או בקשות בנושא מדיניות הפרטיות, אתם מוזמנים ליצור איתנו קשר:
          </Paragraph>
          <Paragraph>
            <strong>אפיק לב - ייעוץ משכנתאות</strong><br />
            טלפון: 054-882-7511<br />
            דוא"ל: afiklev@gmail.com<br />
            כתובת: שירות בפריסה ארצית
          </Paragraph>
          <Paragraph>
            <strong>רשות להגנת הפרטיות:</strong><br />
            טלפון: 02-6556666<br />
            אתר: <a href="https://www.gov.il/he/departments/the_privacy_protection_authority" target="_blank" rel="noopener noreferrer">www.gov.il</a>
          </Paragraph>
        </ContactInfo>

        <Section style={{ textAlign: 'center', marginTop: '3rem', fontSize: '0.9rem', color: '#999' }}>
          <Paragraph>מדיניות זו עודכנה לאחרונה: דצמבר 2024</Paragraph>
        </Section>
      </PrivacyWrapper>
    </motion.div>
  );
};

export default Privacy;
